import { render, staticRenderFns } from "./ReviewsCategoriesTableRow.vue?vue&type=template&id=d445f78a&scoped=true&"
import script from "./ReviewsCategoriesTableRow.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesTableRow.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesTableRow.vue?vue&type=style&index=0&id=d445f78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d445f78a",
  null
  
)

export default component.exports